const CustomerStatus = {
  Active: 'active',
  Inactive: 'inactive',
  Terminated: 'terminated',
  Delinquent: 'delinquent',
  Pending: 'pending',
  Rejected: 'rejected',
  Claimed: 'claimed'
};

export default CustomerStatus;
